module.exports = __webpack_public_path__ + "media/images/athletes/1655-3386bba9d5714f422a4f703de609a702.png";